export default `
§ uiKit.console.button: 복사
§ uiKit.console.notification: 텍스트가 복사되었습니다
§ uiKit.dataLoader.page: 페이지
§ uiKit.dataLoader.size: 에 의해 표시
§ uiKit.dataLoader.rows: 라인.
§ uiKit.dataLoader.from: 에서
§ uiKit.dataLoader.all: 모두 보기
§ uiKit.hoursChart.work: 표준 근무 시간(평일 07:00~20:00)
§ uiKit.hoursChart.weekend: 근무일 전/후 주말 또는 시간
§ uiKit.hoursChart.days: 특정 요일 및 시간의 모든 시간에 대한 총 커밋 수
§ uiKit.page.remove: 제거
§ uiKit.nothingFound.common.title: 표시 할 데이터가 없거나 부족합니다
§ uiKit.nothingFound.common.description: 커밋이 형식으로 서명되면 시스템은 더 많은 데이터를 처리합니다.:
§ uiKit.nothingFound.common.console: 작업 번호 유형(기능):설명
§ uiKit.nothingFound.common.example: 예를 들어:
§ uiKit.nothingFound.staff.title: 이 직원에 대한 데이터가 없습니다
§ uiKit.nothingFound.staff.description1
그는 매일 편집을하지 않았고"조수"의 지위를 받았습니다.
이 프로젝트에서이 상태를 가진 직원의 작업은 블라드가 일반적인 배경에 비해 중요하지 않기 때문에 무시 될 수 있습니다.
§ uiKit.nothingFound.staff.description2
따라서 시스템은 그것에 대한 여러 지표를 계산하지 않습니다.
이것이 오류이고 이 직원을 일반 직원으로 계산해야 하는 경우"설정"섹션으로 이동하여 유형을 변경하십시오.
§ common.title: 힘내 통계
§ common.filters: 필터
§ common.notifications.save: 변경 사항이 저장됩니다
§ common.notifications.setting: 설정이 저장됩니다
§ common.fileLoader.notification: 파일 업로드 오류$1
`;
